<div class="container section">

  <div class="row pagetitle-row" [hidden]="isSectionApp">
    <div class="pagetitle">
      <div class="nav-icons sections"><i class="fa fa-chevron-up fa-2x" aria-hidden="true"></i></div>
      <h1 class="sections">Sections</h1>
    </div>
  </div>


  <form class="full-width" novalidate (ngSubmit)="save()" [formGroup]="sectionForm">
    <h3 *ngIf="!isSectionApp">My Sections</h3>

    <p *ngIf="isSectionApp">
      Connect with colleagues who share your areas of interest in emergency medicine. Visit the <a target="_blank"
        href="https://www.acep.org/sections"></a>ACEP Sections page for
      more information on each section, dues and benefits. Section membership includes access to the section e-list,
      e-newsletter, section website and the opportunity to participate in the section grant program. It also provides a
      pathway for professional leadership development.<br><br>
    </p>

    <div class="row">
      <div class="col-md-12">
        <div class="alert alert-success" *ngIf="freeSectionsPresent && showFreeSectionMarketing">
          <strong>** Free Section for your Membership Type!</strong>
        </div>

        <div class="alert alert-warning">
          <p>
            <strong>Selected Sections: {{GetSelectedSections()}}</strong>
          </p>

        </div>

      </div>
    </div>

    <div class="row">
      <div formArrayName="sections">
        <div *ngFor="let scn of sectionFormArray.controls; let idx = index" [formGroupName]="idx" class="sectionnode">
          <div class="col-xs-6 col-md-3">
            <div class="thumbnail">
              <div class="thumbheader">
                <mat-checkbox color="primary" formControlName="selected"
                  [disabled]="scn.get('enabled').value == false"></mat-checkbox>
                <span class="sectionname">
                  {{showFreeSectionMarketing && scn.get('isFree').value ? '**' : ''}} {{scn.get('name').value}}</span>
                <span class="descTrigger">
                  <i class="fa fa-2x fa-angle-down" aria-hidden="true"></i>
                </span>
              </div>
              <div class="thumbbody">
                <div class="section">
                  <div class="preview">
                    <img class="img-responsive" src="{{scn.get('img').value}}">
                  </div>
                  <div class="description">
                    <span> {{scn.get('description').value}}</span>
                    <a href="{{scn.get('url').value}}" target="_blank">
                      Read more
                      <i class="fa fa-1x fa-external-link" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- <div class="col-xs-6 col-md-3">
      <div class="thumbnail">
        <div class="thumbheader">
          <mat-checkbox color="primary"></mat-checkbox>
          Air Medical Support
          <span class="descTrigger">
            <i class="fa fa-3x fa-angle-down" aria-hidden="true"></i>
          </span>
        </div>
        <div class="section">
          <div class="preview">
            <img class="img-responsive" src="https://www.acep.org/globalassets/sites/acep/media/sections-logos/small/airtransportlogo_sm.png">
          </div>
          <div class="description">
            <span> Ensures that air medical transport is used to benefit patients while providing the highest standard of care in
              a safe and effective manner.</span>
            <a href="#" target="_blank">
              Read more
              <i class="fa fa-1x fa-external-link" aria-hidden="true"></i>
            </a>

          </div>
        </div>

      </div>
    </div> -->



    <div>
    </div>



    <div class="row actions">
      <div class="col-md-12">
        <button mat-raised-button class="btnSave"
          [disabled]="isSectionApp && SelectedSections?.length == 0">{{isSectionApp ? 'Checkout' : 'Save and
          Continue'}}</button>
      </div>
    </div>

  </form>
  <pre *ngIf="isDevEnv">
  <code>
    {{ sectionForm.value | json }}
  </code>
</pre>


</div>